import { Directive, inject } from '@angular/core';
import { NgControl } from '@angular/forms';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[phonenumber]' })
export class PhonenumberDirective {
  constructor() {
    const ngControl = inject(NgControl);

    const phoneUtil = PhoneNumberUtil.getInstance();
    const valueAccessor = ngControl.valueAccessor!;
    const { registerOnChange } = valueAccessor;

    valueAccessor.registerOnChange = (fn: any) =>
      registerOnChange.call(valueAccessor, (value: any) => {
        try {
          const number = phoneUtil.parse(value, 'DE');
          const newValue = phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL);
          if (newValue !== value) {
            ngControl.control?.patchValue(newValue, { emitModelToViewChange: true });
          }
          value = newValue;
        } catch {
          // keep original value when parsing fails
        }
        return fn(value);
      });
  }
}
